module.exports = __webpack_public_path__ + "img/boite1.54a5d8fb.png";